import React from 'react';
import logError from 'App/babel/helpers/logError';
import T from 'Components/Helpers/translate';
import SupersearchHistory from 'Components/Supersearch/SupersearchHistory';
import SupersearchResultHeader from 'Components/Supersearch/SupersearchResultHeader';
import {
	SupersearchResultRowClient,
	SupersearchResultRowContact,
	SupersearchResultRowActivity,
	SupersearchResultRowAppointment,
	SupersearchResultRowOrder,
	SupersearchResultRowOpportunity
} from 'Components/Supersearch/SupersearchResultRow';
import { Icon } from '@upsales/components';
import SupersearchNoResults from './SupersearchNoResults';
import SupersearchAIActions from './SupersearchAIActions';
import history from 'App/pages/routes/history';
import { openEditAppointment } from 'Components/Modals/Appointment/EditAppointment';
import { openEditOrder } from 'App/components/EditOrder';
import ReactCreateClass from 'create-react-class';
import { getAllowedCountries, StatusCategory } from 'App/services/prospectingService';
import Prospecting from 'App/babel/resources/Prospecting';
import Quicksearch from 'App/resources/Quicksearch';
import RequestBuilder, { comparisonTypes } from 'App/babel/resources/RequestBuilder';
import OldLoader from 'App/babel/components/LegacyReactTemplates/oldLoader';
import BrowserService from 'Services/BrowserService';

const SUPERSEARCH_PROSPECTING_LIMIT = 5;

const onProspectingSearch = function (searchStr) {
	const trimmed = searchStr ? searchStr.trim() : '';
	if (trimmed.length < 2) {
		return Promise.resolve({ data: [], metadata: { total: 0 } });
	}
	const countries = getAllowedCountries();
	if (!countries.length) {
		return Promise.resolve({ data: [], metadata: { total: 0 } });
	}
	const primaryCountry = countries[0];

	const rb = new RequestBuilder();
	rb.addFilter({ field: 'headquarters' }, comparisonTypes.Equals, true);
	rb.addFilter({ field: 'statusCategory' }, comparisonTypes.Equals, [
		StatusCategory.ActiveWithWarning,
		StatusCategory.Active
	]);
	rb.addFilter({ field: 'name' }, comparisonTypes.Search, trimmed);
	// revenueSort is unavailable for NO/FI — fall back to plain revenue there
	if (primaryCountry === 'NO' || primaryCountry === 'FI') {
		rb.addSort('revenue', false);
	} else {
		rb.addSort('revenueSort', false);
	}
	rb.fields = ['prospectingId', 'name', 'orgNumber', 'visitingTown', 'postTown', 'registeredTown'];
	rb.limit = SUPERSEARCH_PROSPECTING_LIMIT;
	rb.extraParams.push({ key: 'country', value: primaryCountry });

	const filters = rb.build();
	filters.countries = countries;

	return Prospecting.find(filters);
};

const onSearch = function (searchStr, ts, options) {
	var searchValue = searchStr.split(' ');
	searchValue.length = 15;
	searchValue = searchValue.join(' ');
	searchValue = searchValue.trim();
	return Quicksearch.search(searchValue, ts, options).then(function (results) {
		var res = { numResults: 0, data: {}, ts: results.ts };
		Object.values(results).forEach(function (entity) {
			var data = entity.data;
			var type = entity.type;
			if (/^(client|activity|opportunity|appointment|order|contact|subAccount)$/.test(type)) {
				res.data[type] = entity;
			}

			if (data) {
				res.numResults += data.length;
			}
		});

		return res;
	});
};

const rowComponents = {
	client: { component: SupersearchResultRowClient, fieldKey: 'account' },
	subAccount: { component: SupersearchResultRowClient, fieldKey: 'account' },
	contact: { component: SupersearchResultRowContact, fieldKey: 'contact' },
	activity: { component: SupersearchResultRowActivity, fieldKey: 'activity' },
	appointment: { component: SupersearchResultRowAppointment, fieldKey: 'appointment' },
	order: { component: SupersearchResultRowOrder, fieldKey: 'order' },
	opportunity: { component: SupersearchResultRowOpportunity, fieldKey: 'opportunity' }
};

var superSearchTimeout = null;
const Supersearch = ReactCreateClass({
	getInitialState: function () {
		return {
			open: false,
			value: '',
			highlightedResult: 0,
			numResults: 0,
			loading: false,
			error: false,
			results: {},
			showMoreOf: null,
			limits: this.resetLimits(),
			prospectingResults: [],
			prospectingLoading: false,
			prospectingError: false
		};
	},
	setLanguage: function () {
		this.lang = {
			command: T('default.command'),
			placeholder: T('default.searchUpsales'),
			advancedTitle: T('filters.advancedSearch'),
			noResults: T('default.noResults'),
			typeToSearch: T('default.typeToSearch'),
			client: T('default.accounts'),
			subAccount: T('account.subaccounts'),
			contact: T('default.contacts'),
			activity: T('default.activities'),
			opportunity: T('default.opportunities'),
			order: T('default.orders'),
			name: T('default.name'),
			email: T('default.email'),
			appointment: T('default.appointments'),
			more: T('filters.more').toLowerCase(),
			accountHasActivity: T('search.accountHasActivity'),
			accountHasNoActivity: T('search.accountHasNoActivity'),
			showAll: T('default.showAll'),
			result: {
				subAccount: T('default.subaccountResult').toLowerCase(),
				client: T('default.accountResult').toLowerCase(),
				contact: T('default.contactResult').toLowerCase(),
				activity: T('default.activityResult').toLowerCase(),
				opportunity: T('default.opportunityResult').toLowerCase(),
				order: T('default.orderResult').toLowerCase(),
				appointment: T('default.appointmentResult').toLowerCase()
			},
			thatMatches: T('default.thatMatches').toLowerCase(),
			inactive: T('default.inactive').toLowerCase(),
			description: T('default.description'),
			get: T('soliditet.get'),
			results: T('default.results').toLowerCase(),
			resultSingular: {
				client: T('default.account').toLowerCase(),
				contact: T('default.contact').toLowerCase(),
				activity: T('default.activity').toLowerCase(),
				opportunity: T('default.opportunity').toLowerCase(),
				order: T('default.order').toLowerCase(),
				appointment: T('default.appointment').toLowerCase()
			},
			searchError: T('listError.default'),
			searchSmartInUpsales: T('navbar.quickSearch.searchSmartInUpsales'),
			phonenumberExplanation: T('navbar.quickSearch.phonenumberExplanation'),
			phone: T('tag.contact.phone'),
			shortcut: T('navbar.quickSearch.shortcut'),
			shortcutExplanation: T('navbar.quickSearch.shortcutExplanation'),
			quickNav: T('navbar.quickSearch.quickNav'),
			quickNavExplanation1: T('navbar.quickSearch.quickNavExplanation.1'),
			quickNavExplanation2: T('navbar.quickSearch.quickNavExplanation.2'),
			quickNavExplanation3: T('navbar.quickSearch.quickNavExplanation.3')
		};
	},
	componentDidMount: function () {
		this.setLanguage();

		var meta = Tools.AppService.getMetadata();
		this.currency = _.find(meta.customerCurrencies, { masterCurrency: true }).iso;

		this.moreTypes = {
			client: this.lang.name.toLowerCase(),
			contact: this.lang.name.toLowerCase(),
			activity: this.lang.description.toLowerCase(),
			opportunity: this.lang.description.toLowerCase(),
			order: this.lang.description.toLowerCase(),
			appointment: this.lang.description.toLowerCase()
		};

		document.addEventListener('keydown', this.openOnShortCut);
		document.addEventListener('openSearch', this.open);
	},
	componentWillUnmount: function () {
		document.removeEventListener('keydown', this.openOnShortCut);
		document.removeEventListener('openSearch', this.open);
	},
	componentDidUpdate: function () {
		var self = this;
		var field = self.getField();
		if (self.state.open) {
			field.focus();

			var form = self.getForm();
			var containerHeight = window.innerHeight - 10;
			var resultWrap = this.getResults();

			if (form.scrollHeight > containerHeight && !form.classList.contains('large')) {
				form.classList.add('large');
			}
			resultWrap.style.maxHeight = window.innerHeight - 10 - 16 - 40 + 'px';
		} else {
			field.blur();
		}
	},
	openOnShortCut: function (e) {
		const isOpenCommand = BrowserService.isFirefox()
			? BrowserService.isOptionCombinedKey(e, 56, true) // Cannot override cmd+shift+7 in firefox
			: BrowserService.isOptionCombinedKey(e, 55, true);
		// Cmd/Ctrl+K (keyCode 75) without shift
		const isCmdK = e.keyCode === 75 && !e.shiftKey && (e.metaKey || e.ctrlKey);
		if (isCmdK) {
			e.preventDefault();
			if (this.state.open) {
				this.close();
			} else if (!document.body.classList.contains('modal-open')) {
				this.open();
			}
			return;
		}
		if (isOpenCommand && !document.body.classList.contains('modal-open')) {
			this.open();
		}
	},
	reFocus: function () {
		if (this.state.open) {
			this.getField().focus();
		}
	},
	getField: function () {
		return this._searchField;
	},
	getResults: function () {
		return this._resultsWrap;
	},
	getForm: function () {
		return this._form;
	},
	getCurtain: function () {
		return this._curtain;
	},
	getValue: function () {
		return this._searchField.value;
	},
	moveDown: function () {
		const rowSelector = '.SupersearchResultRow';
		const rowSelectedClass = 'SupersearchResultRow--selected';
		const resultWrap = jQuery(this.getResults());
		const selected = resultWrap.find(`${rowSelector}.${rowSelectedClass}`);
		const results = resultWrap.find(rowSelector);
		const index = jQuery(rowSelector).index(selected);

		// check if there is one more
		if (index !== results.length - 1) {
			selected.removeClass(rowSelectedClass);
			jQuery(results[index + 1]).addClass(rowSelectedClass);
		} else {
			selected.removeClass(rowSelectedClass);
			jQuery(results[0]).addClass(rowSelectedClass);
		}
	},
	moveUp: function () {
		const rowSelector = '.SupersearchResultRow';
		const rowSelectedClass = 'SupersearchResultRow--selected';
		const resultWrap = jQuery(this.getResults());
		const selected = resultWrap.find(`${rowSelector}.${rowSelectedClass}`);
		const results = resultWrap.find(rowSelector);
		const index = jQuery(rowSelector).index(selected);

		// check if there is one more
		if (index !== 0) {
			selected.removeClass(rowSelectedClass);
			jQuery(results[index - 1]).addClass(rowSelectedClass);
		} else {
			selected.removeClass(rowSelectedClass);
			jQuery(results[results.length - 1]).addClass(rowSelectedClass);
		}
	},
	goToAdvanced: function () {
		this.close();
		history.push('/advanced-search/accounts');
	},
	close: function () {
		if (!this.state.open) {
			return;
		}
		this.setState({ open: false });
	},
	openCreateAccount: function () {
		const name = this.state.value?.trim() || '';
		this.close();
		const account = Tools.Account.new();
		account.name = name;
		Tools.$upModal.open('editAccount', {
			account: account,
			customerId: Tools.AppService.getCustomerId()
		});
	},
	open: function () {
		if (this.state.open) {
			return;
		}
		$(this.getField()).select();
		this.setState({ open: true });
	},
	resultClick: function (row, type) {
		this.close();
		this.setState({
			value: ''
		});

		var options = {};
		switch (type) {
			case 'client':
			case 'subAccount':
				return Tools.$state.go('account.dashboard', { id: row.id });
			case 'contact':
				return Tools.$state.go('contact.dashboard', { id: row.id });
			case 'activity':
				options.id = row.id;
				return Tools.$upModal.open('editActivity', options);
			case 'opportunity':
			case 'order':
				options.id = row.id;
				return openEditOrder(options);
			case 'appointment':
				options.id = row.id;
				return openEditAppointment(options);
		}
	},
	resetLimits: function () {
		return {
			client: 5,
			subAccount: 5,
			contact: 5,
			activity: 5,
			appointment: 5,
			order: 5,
			opportunity: 5
		};
	},
	showMore: function (type) {
		var self = this;

		if (superSearchTimeout) {
			clearTimeout(superSearchTimeout);
			superSearchTimeout = null;
		}

		superSearchTimeout = setTimeout(function () {
			var limits = self.state.limits;
			limits[type] += 5;

			var options = { type: type };
			options[type + 'Limit'] = limits[type];

			onSearch(self.state.value, self.searchTimestamp, options)
				.then(function (res) {
					self.state.results[type] = res.data[type];
					self.setState({
						results: self.state.results
					});
				})
				.catch(e => {
					logError(e, 'Failed searching');
				});

			self.setState({
				limits: limits
			});
		}, 200);
	},
	searchTimestamp: null,
	prospectingTimestamp: null,
	searchProspecting: function (searchValue) {
		var self = this;
		var hasProspecting =
			Tools.FeatureHelper.hasSoftDeployAccess('SUPERSEARCH_PROSPECTING') &&
			Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.PROSPECTING_BASIC);

		if (!hasProspecting) {
			return;
		}

		var ts = Date.now();
		self.prospectingTimestamp = ts;

		self.setState({
			prospectingLoading: true,
			prospectingError: false,
			prospectingResults: []
		});

		onProspectingSearch(searchValue)
			.then(function (res) {
				if (self.prospectingTimestamp !== ts) {
					return;
				}
				self.setState({
					prospectingLoading: false,
					prospectingResults: res.data || []
				});
			})
			.catch(function (e) {
				if (self.prospectingTimestamp !== ts) {
					return;
				}
				logError(e, 'Failed prospecting search in supersearch');
				self.setState({
					prospectingLoading: false,
					prospectingError: true
				});
			});
	},
	search: function () {
		this.searchTimestamp = Date.now();
		var self = this;
		self.setState({
			limits: this.resetLimits(),
			value: self.getValue() || '',
			loading: true,
			error: false,
			numResults: 0,
			results: {},
			highlightedResult: null,
			prospectingResults: [],
			prospectingLoading: false,
			prospectingError: false
		});

		if (superSearchTimeout) {
			clearTimeout(superSearchTimeout);
			superSearchTimeout = null;
		}

		superSearchTimeout = setTimeout(function () {
			var searchValue = self.state.value;
			onSearch(searchValue, self.searchTimestamp)
				.then(function (res) {
					if (!self.searchTimestamp || self.searchTimestamp === res.ts) {
						var selected = null;
						var selectedSort = 0;
						_.each(res.data, function (sectionRes, type) {
							if ((!selected || sectionRes.sortOrder < selectedSort) && sectionRes.data.length) {
								selected = type + '-' + sectionRes.data[0].id;
								selectedSort = sectionRes.sortOrder;
							}
						});

						self.setState({
							loading: false,
							results: res.data,
							numResults: res.numResults,
							highlightedResult: selected
						});

						// When CRM returns no results, automatically search external databases
						if (res.numResults === 0 && searchValue.length >= 2) {
							self.searchProspecting(searchValue);
						}
					} else {
						self.setState({ loading: false });
					}
				})
				.catch(function () {
					self.setState({
						loading: false,
						error: true
					});
				});
		}, 500);
	},
	keyDown: function (e) {
		// Prevent tab
		if (e.keyCode === 9) {
			e.preventDefault();
			e.stopPropagation();
			if (e.shiftKey) {
				this.moveUp();
			} else {
				this.moveDown();
			}
		}

		// escape
		if (e.keyCode === 27) {
			this.close();
		}

		// enter
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();

			const rowSelector = '.SupersearchResultRow--selected';

			// open selected result
			var resultWrap = jQuery(this.getResults());
			resultWrap.find(rowSelector).click();
		}

		// up or down arrow
		if (e.keyCode === 38 || (e.keyCode === 40 && this.state.numResults)) {
			// preventDefault
			e.preventDefault();

			// up
			if (e.keyCode === 38) {
				this.moveUp();
			} else if (e.keyCode === 40) {
				// down
				this.moveDown();
			}
		}
	},

	render: function () {
		this.setLanguage();
		var self = this;
		var features = Tools.AppService.getAccountSelf().features;
		var results = this.state.results;
		var minCharForSearch = 2;
		var noResults =
			!this.state.loading && this.state.numResults === 0 && this.state.value.length >= minCharForSearch;
		var showSpinner = this.state.loading && this.state.value.length >= minCharForSearch;

		var headerIcons = {
			client: 'home',
			subAccount: 'subaccounts',
			contact: 'user',
			activity: 'activity',
			appointment: 'calendar',
			opportunity: 'pipeline',
			order: 'dollar'
		};

		var formClass = 'search-form';

		if (this.state.open) {
			formClass += ' focused';
		}
		if (this.props.size === 'md') {
			formClass += ' md';
		}

		var resRows = [];
		if (
			this.state.value.length >= minCharForSearch &&
			this.state.numResults !== 0 &&
			!this.state.loading &&
			!this.state.error
		) {
			var res = Object.values(results).sort((a, b) => a.sortOrder - b.sortOrder);
			res?.forEach(sectionRes => {
				var type = sectionRes.type;

				var numberOfLoadingRows = 0;
				if (self.state.limits[type] - sectionRes.metadata.limit !== 0) {
					numberOfLoadingRows = Math.min(
						self.state.results[type].metadata.total - sectionRes.metadata.limit,
						5
					);
				}

				if (sectionRes.metadata.total) {
					var section = [
						<SupersearchResultHeader
							key={'header-' + type}
							title={`${sectionRes.metadata.total} ${self.lang[type].toLowerCase()}`}
							icon={headerIcons[type]}
						/>,
						sectionRes.data.map((row, i) => {
							const NewComponent = rowComponents[type].component;
							const selected = type + '-' + row.id === this.state.highlightedResult;
							return (
								<NewComponent
									key={'results-' + type + '-' + i}
									item={row}
									onClick={() => this.resultClick(row, type)}
									searchStr={this.state.value}
									customFields={this.props.searchableFields[rowComponents[type].fieldKey]}
									closeSearch={this.close}
									defaultCurrency={this.currency}
									selected={selected}
								/>
							);
						})
					];
					if (numberOfLoadingRows > 0) {
						var height = 50 * numberOfLoadingRows + 'px';
						section.push(
							<div style={{ height: height }} className="loading" key="loading-more">
								<OldLoader />
							</div>
						);
					} else if (sectionRes.metadata.total > results[type].data.length) {
						var numberOfRowsToFetch = Math.min(
							self.state.results[type].metadata.total - sectionRes.metadata.limit,
							5
						);
						section.push(
							<div
								className="search-result more-results"
								onClick={self.showMore.bind(self, type, null)}
								key={`show-more-${type}`}
							>
								{self.lang.get} {numberOfRowsToFetch} {self.lang.more}{' '}
								{numberOfRowsToFetch === 1 ? self.lang.resultSingular[type] : self.lang.result[type]}
							</div>
						);
					}

					resRows.push(section);
				}
			});
		}

		var advancedSearchToggle = null;
		if (features.advancedSearch) {
			advancedSearchToggle = (
				<button id="advanced-toggle" className="btn btn-link" type="button" onClick={this.goToAdvanced}>
					<Icon name="sliders" />
					<span>{self.lang.advancedTitle}</span>
				</button>
			);
		}

		const renderMediumSearchBar = this.props.size === 'md';
		return (
			<form
				autoComplete="off"
				className={formClass}
				role="search"
				ref={el => {
					this._form = el;
				}}
			>
				<div
					id="search-curtain"
					ref={el => {
						this._curtain = el;
					}}
					className={this.state.open ? 'visible' : ''}
					onClick={this.close}
				/>
				<ul className="nav-menu small-search">
					<li className="menu-item">
						<a id="search-toggle" onClick={this.open}>
							<b className="icon fa fa-search" />
						</a>
					</li>
				</ul>
				<div className={`navbar-search ${renderMediumSearchBar ? 'medium-search' : 'large-search'}`}>
					<b className="fa fa-search" />
					<input
						autoComplete="upsales-quicksearch"
						type="text"
						className="nav-search-input"
						ref={el => {
							this._searchField = el;
						}}
						max="30"
						placeholder={self.lang.placeholder}
						value={this.state.value}
						onChange={this.search}
						onFocus={this.open}
						onKeyDown={this.keyDown}
						data-test-id="quicksearch-input"
					/>
					{advancedSearchToggle}
				</div>
				<div
					id="search-results"
					ref={el => {
						this._resultsWrap = el;
					}}
				>
					{noResults && !this.state.error ? (
						<SupersearchNoResults
							query={this.state.value}
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
							onAddCompany={this.openCreateAccount}
							prospecting={
								Tools.FeatureHelper.hasSoftDeployAccess('SUPERSEARCH_PROSPECTING') &&
								Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.PROSPECTING_BASIC)
									? {
											results: this.state.prospectingResults,
											loading: this.state.prospectingLoading,
											error: this.state.prospectingError,
											onCompanyAdded: () => {
												this.close();
												this.setState({ value: '' });
											}
									  }
									: undefined
							}
						/>
					) : null}

					{this.state.error && (
						<span className="search-error">
							<b className="fa fa-warning" /> {self.lang.searchError}
						</span>
					)}

					{showSpinner ? (
						<div className="loading">
							<OldLoader />
						</div>
					) : null}

					{resRows}
					{!showSpinner && !resRows.length && !noResults && !this.state.error ? (
						<SupersearchHistory
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
						/>
					) : null}

					{!this.state.error && !noResults && resRows.length > 0 && (
						<SupersearchAIActions
							query={this.state.value}
							closeSearch={() => {
								this.close();
								this.setState({ value: '' });
							}}
						/>
					)}
				</div>
			</form>
		);
	}
});

export default Supersearch;
